$(function() {
    "use strict";

    $(document).ready(function() {

        var $modal       = $('.modall'),
            $openModal   = $('.i-open-modal'),
            $closeModal  = $('.i-close-modal'),
            openedModals = [],

            $spaceNode      = $('.layout'),
            $paddingNodes   = $(),
            shownClass      = 'modall_shown',
            windowScrollTop = 0,
            scrollbarSize   = 0;

        function overflowiseLayout () {

            if (!Modernizr.touch || $('.layout_mobilised').length > 0) {

                var $html       = $('html:first'),
                    widthBefore = $html.width();

                $paddingNodes = $('.header[style*=fixed] .header__top-line,' +
                                  '.header[style*=fixed] .header__bottom-line');

                windowScrollTop = $(window).scrollTop();

                var setStyle = function () {

                    $spaceNode.css({
                        'height': $(window).height() + windowScrollTop,
                        'margin-top': windowScrollTop * -1,
                        'overflow': 'hidden'
                    });

                    if (0 === scrollbarSize) {
                        scrollbarSize = $html.width() - widthBefore;
                        $spaceNode.css('padding-right', '+=' + scrollbarSize);
                        $paddingNodes.css('padding-right', '+=' + scrollbarSize);
                    }
                };

                setStyle();
                $(window).on('debouncedresize.Modal', function() {
                    setStyle();
                });
            }
        }

        function deoverflowiseLayout () {

            if (!Modernizr.touch || $('.layout_mobilised').length > 0) {

                scrollbarSize = 0;
                $spaceNode.css({
                    'height': '',
                    'margin-top': '',
                    'overflow': '',
                    'padding-right': ''
                });
                $paddingNodes.css('padding-right', '');
                $paddingNodes = $();
                $(window).scrollTop(windowScrollTop);
                $(window).off('debouncedresize.Modal');
            }
        }

        function hitPageView (absoluteUrl, title, referer) {
            if ('undefined' !== typeof window.Tracker) {
                window.Tracker.pushPageView(absoluteUrl, title, referer);
            }
        }

        function openModal (matcher, vpUrl, $opener) {
            var $modal;
            var id;

            if (_(matcher).isObject()) {
                $modal = matcher;
                id = matcher.prop('id');
            }

            if (_(matcher).isString()) {
                id = matcher;
                $modal = $('#' + id);
            }

            if (_(vpUrl).isString()) {
                hitPageView(vpUrl);
            }

            if (openedModals.length < 1) {
                overflowiseLayout();
            }

            $modal.data('opener', $opener);

            if ($opener) {
                if ($opener.data('toggle-class')) {
                    $opener.addClass($opener.data('toggle-class'));
                }
            }

            openedModals = _.uniq(openedModals.push(id));

            $modal.addClass(shownClass)
            .afterTransition(function () {
                $(document).trigger('Modal::open', [$modal]);
            });

            var setModalStyle = function () {
                $modal.css(
                    'height', Math.max($(window).outerHeight(true), $('.layout').outerHeight(true))
                )
            };

            var setBackdopStyle = function () {
                var $backdrop = $modal.find('.modall__backdrop');
                var $modalWindow   = $modal.find('.modall__window');
                var modalWindowHeight = $modalWindow.outerHeight(true);

                if (modalWindowHeight > $(document).outerHeight(true)) {
                    $backdrop.css({
                        'position': 'absolute',
                        'height': modalWindowHeight
                    });
                }
                else {
                    $backdrop.css({
                        'position': '',
                        'height': ''
                    });
                }
            };

            if (!Modernizr.touch || $('.layout_mobilised').length > 0) {

                setModalStyle();
                setBackdopStyle();
                $(window).on('debouncedresize.Modal', function () {
                    setBackdopStyle();
                    setModalStyle();
                });
            }
        }

        function closeModal (matcher) {
            var $modal;
            var id;

            if (_(matcher).isObject()) {
                $modal = matcher;
                id = matcher.prop('id');
            }

            if (_(matcher).isString()) {
                id = matcher;
                $modal = $('#' + id);
            }

            if (openedModals.length < 1) {
                deoverflowiseLayout();
            }

            openedModals = _.without(openedModals, id);

            $modal.removeClass(shownClass);

            var $opener = $modal.data('opener');

            if ($opener) {

                if ($opener.data('toggle-class')) {
                    $opener.removeClass($opener.data('toggle-class'));
                }
            }

            if (!Modernizr.touch || $('.layout_mobilised').length > 0) {
                $modal.css('height', '');
            }

            $modal.afterTransition(function () {
                $(document).trigger('Modal::close', [$modal]);
            });
        }

        $(document).on('click', $openModal.selector, function(event) {
            event.preventDefault();
            var $this = $(this);
            var id = $this.data('modal-id');
            var vpUrl = $this.data('vp-url');

            var shutOpen = function () {
                openModal(id, vpUrl, $this);
            };

            if ($this.is('.i-close-modal')) {
                var newModal = $('#' + id);
                newModal.addClass('modall_no-animation');
                newModal.css('z-index', '99999');

                closeModal($(this).parents('[id]').attr('id'));
                _.defer(function () {
                    shutOpen();
                    _.defer(function () {
                        newModal.removeClass('modall_no-animation');
                        newModal.css('z-index', '');
                    });
                });
            }
            else {
                shutOpen();
            }
        });

        $(document).on('click', $closeModal.selector, function(event) {
            event.preventDefault();
            var id = $(this).data('modal-id') || $(this).closest($modal).attr('id').replace('#', '');
            closeModal(id);
        });

        $(document).on('Form::Success', function (event, $element) {

        });

        // Exports
        window.Modal = {};
        Modal.openModal = openModal;
        Modal.closeModal = closeModal;
    });
});